import { IDateRangeFilter } from "@/types/parcel-filter.types";

export const isInDateRange = (
  dateStr: string | null | undefined,
  range: IDateRangeFilter,
): boolean => {
  if (!range.start && !range.end) return true;
  if (!dateStr) return false;
  const date = new Date(dateStr);
  if (range.start && date < new Date(range.start)) return false;
  if (range.end) {
    const endDate = new Date(range.end);
    endDate.setHours(23, 59, 59, 999);
    if (date > endDate) return false;
  }
  return true;
};
